module.exports = __webpack_public_path__ + "img/auth-阿虎医考-山河教育授权书.039c7661.png";